// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"133":"50b10337b4adc686","174":"3af3f0cfc63eb05f","233":"7743954d043c4714","300":"f8138d9482f8145c","350":"11ec467febc3c9e7","363":"b05ec1af28e5432b","406":"d3981f1c62cca36d","728":"2712a6cf0e97fa28","905":"4aefa0f0626ed6fa"}[chunkId] + ".js";
};